import { createContext, useContext, useSyncExternalStore } from "react";

/** 沟通浮层里的二级弹窗必须留在同一顶层容器；普通页面仍沿用 body。 */
export const OverlayPortalContext = createContext(null);
export const useOverlayPortal = () => useContext(OverlayPortalContext);

/** 业务弹窗不能把点击沟通入口当作“点击空白关闭”，否则未保存表单会丢失。 */
export const isCommunicationTarget = (target) => !!target?.closest?.("[data-communication-layer]");

// 全局通知在 App 层挂载，不是 Softphone 的 React 子项；共享宿主可防止手机聊天覆盖错误提示。
let communicationHost = null;
const listeners = new Set();
const subscribe = (listener) => { listeners.add(listener); return () => listeners.delete(listener); };
export const setCommunicationHost = (host) => {
  communicationHost = host;
  listeners.forEach(listener => listener());
};
export const clearCommunicationHost = (host) => { if (communicationHost === host) setCommunicationHost(null); };
export const useCommunicationHost = () => useSyncExternalStore(subscribe, () => communicationHost, () => null);
